<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetSignedStudents"
  >
    <div class="align-items-center display-flex-row m-filters-and-actions space-between">
      <AtomAvatarEquipo
        :avatar-class="'xlarge'"
        :avatar="avatar"
      />
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        @showModal="$modal.showModal"
      />
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="familiaInscriptosMiembros.integrantes.length">
          <th
            class="text-align-left"
            width="24%"
          >
            {{ $t('mEditionMapEnrollmentsFamiliesMembers.table.thMember') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionMapEnrollmentsFamiliesMembers.table.thCountry') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionMapEnrollmentsFamiliesMembers.table.thScore') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionMapEnrollmentsFamiliesMembers.table.thLeader') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionMapEnrollmentsFamiliesMembers.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="miembro in familiaInscriptosMiembros.integrantes"
          :key="miembro.inscripcion"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="medium"
                :user-image="miembro.avatar"
              />
              <span class="display-flex-column user-info">
                <span class="ellipsis">
                  {{ miembro.razon_social }}
                </span>
                <small class="ellipsis font-weight-regular text-color-success">
                  {{ miembro.email }}
                </small>
              </span>
            </span>
          </td>
          <td class="text-align-center">
            <span class="user-info">
              <span
                v-if="miembro.pais"
                class="ellipsis"
              >
                {{ miembro.pais }}
              </span>
              <span v-else>-</span>
            </span>
          </td>
          <td class="text-align-center">
            <span class="user-info">
              <span class="ellipsis">
                {{ miembro.puntos }}
                <i class="fas fa-star text-color-notifications-primary"></i>
              </span>
            </span>
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="miembro.is_lider"
              :disabled="requests.updateFamiliaLider.isRequested"
              :element-id="miembro.alumno"
              method="updateFamiliaLider"
              name="activo"
              :show-loading="requests.updateFamiliaLider.isRequested &&
                requests.updateFamiliaLider.itemLoading === miembro.alumno"
              sliderClass="a-toggle-slider-maps-primary"
              type="checkbox"
              @updateFamiliaLider="updateFamiliaLider"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonSecondary
              :button-secondary="buttonIconRounded.delete"
              :element="{miembro,familia}"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>

</template>

<script>

export default {
  name: 'MoleculeEditionMapEnrollmentsFamilyMembers',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      avatar: {
        firstext: '',
        icon: 'fas fa-star text-color-notifications-primary',
        image: '',
        secondtext: ''
      },

      familia: '',
      familiaInscriptosMiembros: '',

      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary text-color-danger a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapEnrollmentsFamilyMembersModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsFamiliesMembers.tooltip.delete'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-secondary a-button-maps-secondary',
          component: 'MoleculeEditionMapEnrollmentsFamiliesModalAdd',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionMapEnrollmentsFamiliesMembers.buttonSecondary.createText'),
          type: 'button'
        }
      },

      filter: {
        estado: '',
        fecha_creacion: '',
        integrante: '',
        limite: 10,
        nombre_familia: '',
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        deleteFamiliaMiembro: {
          itemLoading: '',
          isRequested: false
        },

        updateFamiliaLider: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = true
      this.readInscripcionesProyecto()
    }
  },

  created () {
    this.readInscripcionesProyecto()
    this.familia = this.$store.getters.getAssetSelectedFamily
    this.avatar.firstext = this.familia.nombre
    this.avatar.image = this.familia.logo
    this.avatar.secondtext = this.familia.puntos
  },
  methods: {

    readInscripcionesProyecto () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('familia', 'readFamiliaMiembros', {}, [this.$route.params.subid], this.filter)
          .then(response => {
            this.familiaInscriptosMiembros = []
            this.familiaInscriptosMiembros = response.data
            this.familiaInscriptosMiembros.integrantes.forEach((integrante) => {
              integrante.is_lider = integrante.is_lider === '1'
            })
            this.pagination.currentQuantity = this.familiaInscriptosMiembros.integrantes.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.familiaInscriptosMiembros = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readFamiliasExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('familia', 'readFamiliasMiembrosExportar', {}, [this.$route.params.subid], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionMapEnrollmentsFamiliesMembers.files.family')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesMembers', 'readFamiliasExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesMembers', 'readFamiliasExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        estado: '',
        fecha_creacion: '',
        integrante: '',
        limite: 10,
        nombre_familia: '',
        pagina: 1
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readInscripcionesProyecto()
    },

    updateFamiliaLider (element) {
      if (!this.requests.updateFamiliaLider.isRequested) {
        this.requests.updateFamiliaLider.isRequested = true
        this.requests.updateFamiliaLider.itemLoading = element.id
        this.$services.update('familia', 'updateFamiliaLider', { lider: element.id }, [this.$route.params.subid])
          .then(response => {
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesMembers', 'updateFamiliaLider', response.data.lider ? 'activationSuccess' : 'deactivationSuccess')
            this.requests.updateFamiliaLider.isRequested = false
            this.readInscripcionesProyecto()
          })
          .catch(error => {
            console.log(error)
            this.familiaInscriptosMiembros.integrantes[this.familiaInscriptosMiembros.integrantes.findIndex(integrantes => integrantes.inscripcion === element.id)].is_lider = +!element.state
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamiliesMembers', 'updateFamiliaLider', 'error', 'a-alert-danger')
            this.requests.updateFamiliaLider.isRequested = false
          })
      }
    }
  }
}
</script>
